import { ChevronDownIcon, Trash2Icon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SavedView } from '@/hooks/use-saved-views';

interface SavedViewsDropdownProps {
  savedViews: SavedView[];
  currentViewId?: string;
  onLoadView: (viewId: string) => void;
  onDeleteView?: (viewId: string) => void;
}

export function SavedViewsDropdown({
  savedViews,
  currentViewId,
  onLoadView,
  onDeleteView,
}: SavedViewsDropdownProps) {
  const currentView = savedViews.find((v) => v.id === currentViewId);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <span className="text-muted-foreground">View:</span>
          {currentView?.name || 'All pulls'}
          <ChevronDownIcon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[200px]">
        <DropdownMenuItem onClick={() => onLoadView('')}>All pulls</DropdownMenuItem>
        {savedViews.length > 0 && <DropdownMenuSeparator />}
        {savedViews.map((view) => (
          <DropdownMenuItem
            key={view.id}
            className="flex items-center justify-between group"
            onClick={() => onLoadView(view.id)}
          >
            <span className="truncate">{view.name}</span>
            {onDeleteView && (
              <button
                className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-destructive/10 rounded"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onDeleteView(view.id);
                }}
                onMouseDown={(e) => e.preventDefault()}
              >
                <Trash2Icon className="h-3 w-3" />
              </button>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
